import { HttpClient, HttpEvent, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class FileService {
  /**
   * Constructor for the class
   * @param _http client
   */
  constructor(private _http: HttpClient) { }

  /**
   * Generate url to upload files
   * @param fileName file's name
   * @returns url
   */
  getUploadUrl(fileName: string) {
    return this._http.get<any>(
      `${environment.bpmApiUrl}/api/files/upload/${fileName}`
    );
  }

  /**
   * Generate url to download files
   * @param fileName file's name
   * @returns url
   */
  getDownloadUrl(fileName: string) {
    return this._http.get<any>(
      `${environment.bpmApiUrl}/api/files/download/${fileName}`
    );
  }

  /**
   * Función para cargar archivos
   * @param url Indica la url para cargar el archivo
   * @param contentType Indica el tipo de contenido a cargar
   * @param file Objeto de tipo archivo a cargar
   * @returns
   */
  uploadFile(url: string, contentType, file) {
    let headers = new HttpHeaders()
      .set("Content-Type", contentType)
      .set("x-ms-blob-type", "BlockBlob");
    return this._http.put<any>(url, file, { headers: headers });
  }

  /**
   * Función que genera la carga del archivo para thumbs
   * @param fileName Indica el nombre del archivo
   * @returns 
   */
  getThumbUploadUrl(fileName: string) {
    return this._http.get<any>(
      `${environment.bpmApiUrl}/api/files/thumb/${fileName}`
    );
  }

  /**
   * Función que convierte una imagen desde url a base64
   * @param imageUrl Url de la imagen
   * @returns base64
   */
  async getBase64ImageFromUrl(url): Promise<string | ArrayBuffer> {
    try {
      // Realizar solicitud HTTP para obtener la imagen
      const imagenBlob = await this._http.get(url, { responseType: 'blob' }).toPromise();

      // Convertir la imagen a base64
      const base64 = await this.convertBlobToBase64(imagenBlob);

      return base64;
    } catch (error) {
      console.error('Error al obtener la imagen:', error);
      throw error;
    }
  }

  convertBlobToBase64(blob: Blob): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }


  /**
   * upload a blob file direct to storage
   * @param file file to upload
   * @param type indicates destiny storage
   * @returns file name in storage
   */
  uploadBlob(file: File, type: string):Promise<{fileName: string}>{
    const formData = new FormData();
    formData.append('file', file, file.name);

    return this._http.post<{fileName: string}>(`${environment.bpmApiUrl}/api/files/upload-blob/${type}`, formData).toPromise();
  }


  /**
   * downloads a blob file from storage
   * @param fileName file name to download
   * @returns blob file
   */
  downloadBlob(fileName: string){
    return this._http.get(`${environment.bpmApiUrl}/api/files/download-blob/${fileName}`, {responseType : 'blob'}).toPromise();
  }


  /**
   * Igual que downloadBlob, pero emite los eventos de la descarga para poder
   * mostrar el progreso
   * @param fileName file name to download
   * @returns eventos de la descarga; el último (Response) trae el blob
   */
  downloadBlobWithProgress(fileName: string): Observable<HttpEvent<Blob>> {
    return this._http.get(`${environment.bpmApiUrl}/api/files/download-blob/${fileName}`,
      { responseType: 'blob', reportProgress: true, observe: 'events' });
  }

}
